var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{class:_vm.btnColor ? _vm.btnColor : 'normal',attrs:{"icon":_vm.$vuetify.breakpoint.xs,"elevation":"3","width":_vm.$vuetify.breakpoint.xs ? '45px' : '200px',"to":_vm.link,"contained":""}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }